const SITE_NAME = 'Instrumental Health'
const SITE_URL = 'https://www.instrumentalhealth.co.uk'
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`
const FOUNDER = 'Kandake Makonnen, BSc (Hons) Medical Herbalist'

export const SEO = {
  siteUrl: SITE_URL,
  siteName: SITE_NAME,
  defaultImage: DEFAULT_IMAGE,

  defaultTitle: `${SITE_NAME} | Holistic Herbal Medicine & Wellness | ${FOUNDER}`,
  defaultDescription:
    "Instrumental Health is a holistic health and wellness platform founded by Kandake Makonnen, BSc (Hons) Medical Herbalist with 20+ years experience. Herbal consultations, women's health, bio-scan assessments, courses, and handcrafted herbal products.",

  pages: {
    home: {
      title: `${SITE_NAME} | Bridging Indigenous Wisdom & Modern Science`,
      description:
        "Holistic herbal medicine, women's health education, bio-scan assessments, and handcrafted herbal products. Founded by BSc Medical Herbalist Kandake Makonnen with 20+ years of clinical experience.",
    },
    about: {
      title: `About Kandake Makonnen | ${SITE_NAME}`,
      description:
        "Discover Kandake's journey from Jamaica to the University of Westminster, with 20+ years bridging traditional African & Caribbean healing wisdom and modern herbal science. BSc (Hons) Medical Herbalist, speaker, and educator.",
    },
    services: {
      title: `Holistic Health Services | ${SITE_NAME}`,
      description:
        "Herbal consultations, women's health support, bio-scan assessments, courses & workshops, herbal walks, and handcrafted remedies. Natural, plant-based approaches for lasting wellbeing.",
    },
    consultations: {
      title: `Herbal Consultations | ${SITE_NAME}`,
      description:
        "Personalised one-to-one herbal consultations exploring root causes of imbalance. Supporting women's health, hormonal balance, menopause, stress, digestion, and chronic conditions. Available online and in-person.",
    },
    scans: {
      title: `Bio-Scan Health Assessment | ${SITE_NAME}`,
      description:
        'A non-invasive Bio-Scan assessment with an 80+ page report, one-to-one feedback session and personalised health summary with practical first steps.',
    },
    integratedHealth: {
      title: `Integrated Health Consultation + Bio-Scan | ${SITE_NAME}`,
      description:
        'A two-hour holistic health consultation and Bio-Scan with a comprehensive scan report, personalised Integrated Health Report and follow-up Zoom session.',
    },
    courses: {
      title: `Herbal Medicine Courses & Workshops | ${SITE_NAME}`,
      description:
        "Transformational educational programmes in herbal medicine, women's health, holistic nutrition, anatomy, and traditional healing systems. In-person and online.",
    },
    workWithMe: {
      title: `3 Month Integrated Health Programme | ${SITE_NAME}`,
      description:
        'A personalised 12-week health programme with consultations, nutritional and lifestyle guidance, herbal medicine where appropriate, progress reviews and a long-term plan.',
    },
    womensHealth: {
      title: `Women's Health Support | ${SITE_NAME}`,
      description:
        'Specialist herbal support for heavy bleeding, fibroids, painful periods, hormonal imbalance, PCOS, menopause, fertility, and womb health. From menarche to menopause and beyond.',
    },
    chronicHealth: {
      title: `Chronic Health Support | ${SITE_NAME}`,
      description:
        'Natural herbal support for chronic conditions including diabetes, hypertension, arthritis, and sickle cell. Holistic, plant-based approaches rooted in clinical experience.',
    },
    books: {
      title: `Books by Kandake Makonnen | ${SITE_NAME}`,
      description:
        "The Cycle of Womanhood: From Menarche to Menopause and Beyond is a transformational three-volume exploration of women's health, herbal medicine, and the sacred journey of womanhood. Coming soon.",
    },
    training: {
      title: `Herbal Walks & Nature Education | ${SITE_NAME}`,
      description:
        'Immersive plant education experiences reconnecting you with the healing intelligence of local plants and ecosystems. 15+ years of herbal walk facilitation across the UK.',
    },
    products: {
      title: `Herbal Products | ${SITE_NAME}`,
      description:
        'Handcrafted herbal remedies rooted in 20+ years of clinical experience and traditional African & Caribbean plant wisdom. Created with intention, integrity, and respect for nature.',
    },
    blog: {
      title: `Health & Wellness Blog | ${SITE_NAME}`,
      description:
        "Articles, insights, and guidance on herbal medicine, women's health, holistic living, and nature-based wellbeing from BSc Medical Herbalist Kandake Makonnen.",
    },
    contact: {
      title: `Contact & Bookings | ${SITE_NAME}`,
      description:
        'Book a herbal consultation, enquire about services, or get in touch with Kandake Makonnen at Instrumental Health. We welcome all enquiries about holistic health and wellbeing.',
    },
  },
} as const
